// https://fusion-api.dev.mos.coke.com/v1/projects/:project_head_id/versions

import { briefApi } from 'api'
import { ApiResponse } from 'types/common/utils'
import { Project } from 'types/Project'

export const fetchProjectDetailed = ({ id }: { id: string }) =>
  briefApi.get<ApiResponse<Project>>(`/projects/${id}/versions`)
